import React from 'react';
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { graphql } from 'react-apollo';
import { Auth } from 'aws-amplify'

import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import LockIcon from '@material-ui/icons/Lock';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ViewComfyIcon from '@material-ui/icons/ViewComfy';
import LabelIcon from '@material-ui/icons/Label';

import UserMenuItems from 'GraphQueries/_Shared/GetUserMenuQuery';

const drawerWidth = 270;

const styles = theme => ({
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: 0,
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        minHeight: 50
    },
    spacer: {
        flex: '1 1 auto'
    }
});

class AppSidebar extends React.Component {

    static defaultProps = {
        menuItems: [],
    }

    constructor(props) {
        super(props);
        this.state = {
            menuItems: this.props.menuItems
        }
    }

    signOut = async () => {
        await Auth.signOut().then(data => this.props.onSignOut());
    }

    componentDidUpdate(prevProps, prevState) {
        const { menuItems } = this.props;
        if (menuItems !== null && menuItems !== undefined) {
            if (prevState.menuItems === null || prevState.menuItems === undefined || prevState.menuItems.length !== menuItems.length) {
                this.setState({ menuItems });
            }
        }
    }

    getIcon = icon => {
        switch (icon) {
            case 'data-tools': return <ViewComfyIcon />
            default: return <LabelIcon />
        }
    }

    toggle = (e, index) => {
        this.setState((prevState, state) => {
            return {
                menuItems: [...prevState.menuItems].sort((a, b) => a.ordinal > b.ordinal).map((x, i) => {
                    return i === index ? Object.assign({}, x, { open: !x.open }) : x;
                })
            }
        })
    }

    navigate = path => {
        const { history, handleSideBarClose } = this.props;
        handleSideBarClose();
        history.push(path);
    }

    render() {
        const { classes, sideBarOpen, handleSideBarClose } = this.props;
        const { menuItems } = this.state;
        return (
            <Drawer variant="permanent" classes={{ paper: classNames(classes.drawerPaper, !sideBarOpen && classes.drawerPaperClose), }} open={sideBarOpen} >
                <div className={classes.toolbar}>
                    <IconButton onClick={handleSideBarClose}><ChevronLeftIcon /></IconButton>
                </div>
                <Divider />
                <List component="nav">
                    {
                        [].concat(menuItems).sort((a, b) => a.ordinal > b.ordinal).map((menuItem, index) =>
                            menuItem.items !== null ? (
                                <React.Fragment key={index}>
                                    <ListItem button onClick={e => this.toggle(e, index)}>
                                        {
                                            menuItem.icon &&
                                            <ListItemIcon>
                                                {
                                                    this.getIcon(menuItem.icon)
                                                }
                                            </ListItemIcon>
                                        }
                                        <ListItemText inset primary={menuItem.label} />
                                        {menuItem.open ? <ExpandLess /> : <ExpandMore />}
                                    </ListItem>
                                    <Collapse in={menuItem.open} timeout="auto" unmountOnExit>
                                        <List component="div" disablePadding>
                                            {
                                                [].concat(menuItem.items).sort((a, b) => a.ordinal > b.ordinal).map((childItem, childIndex) =>
                                                    <ListItem key={childIndex} button className={classes.nested} onClick={event => this.navigate(childItem.path)}>
                                                        <ListItemText inset primary={childItem.label} />
                                                    </ListItem>
                                                )
                                            }
                                        </List>
                                    </Collapse>
                                </React.Fragment>
                            ) :
                                (
                                    <ListItem key={index} button onClick={event => this.navigate(menuItem.path)}>
                                        {
                                            menuItem.icon &&
                                            <ListItemIcon>
                                                {
                                                    this.getIcon(menuItem.icon)
                                                }
                                            </ListItemIcon>
                                        }
                                        <ListItemText primary={menuItem.label} />
                                    </ListItem>
                                )
                        )
                    }
                </List>
                <div className={classes.spacer} />
                <Divider />
                <List>
                    <ListItem button onClick={this.signOut}>
                        <ListItemIcon><LockIcon /></ListItemIcon>
                        <ListItemText primary="Sign Out" />
                    </ListItem>
                </List>
            </Drawer>
        );
    }
}

AppSidebar.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
    menuItems: PropTypes.array.isRequired
};

const StyledSideBar = withStyles(styles, { withTheme: true })(AppSidebar);

export default
    withRouter(
        graphql(UserMenuItems, {
            props: ({ data: { getUserMenu, loading } }) => ({ menuItems: getUserMenu && getUserMenu.items, loading })
        }
        )(StyledSideBar));


// WEBPACK FOOTER //
// ./src/Components/_Shared/AppSidebar.js